<div class="input-container">
  <mat-form-field [class]="options.widthSize || ''">
    <mat-label>{{ options.label || '' }}</mat-label>
    <input
      type="text"
      matInput
      [placeholder]="options.placeholder || ''"
      [value]="options.value || ''"
      [(ngModel)]="options.value"
      (ngModelChange)="onValueChange($event)"
      (keydown)="onKeyDown($event)"
    />

    <button
      [class.hide]="!options.value"
      class="input-container__clear-btn mat-elevation-z0"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="clearAll()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
